import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { RutterSubsidiary } from '@dill/dill-shared';
import { BASE_API_URL } from '../../utils/constants';
import { logoutUser } from './authService';
import { myFirebaseAuth } from '../../firebase/config';

// NetSuite subsidiaries for the connected supplier, used to pick the subsidiary a customer is
// created under. Served from Dill's synced Rutter data, so no slice keeps them — callers read the
// thunk's payload directly.
export const getRutterSubsidiaries = createAsyncThunk(
  'rutter/getRutterSubsidiaries',
  async ({ supplierId }: { supplierId: string }, thunkApi) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }

      const response = await axios.get<{ success: boolean; data: RutterSubsidiary[] }>(
        `${BASE_API_URL}/suppliers/${supplierId}/rutter/subsidiaries`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
